import React from 'react';
import PropTypes from 'prop-types';
import Contracts from '../../../api/api-contracts';
import { BootstrapModal } from 'shared-components/modal/bootstrap-modal';
import { CTAButton } from 'shared-components/buttons/cta-button';
import { FormattedMessage } from 'react-intl';

export class HostCancelConfirmationModal extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      errorText: '',
      spinning: false
    };

    this.updateBookingAction = this.updateBookingAction.bind(this);
    this.handleResponse = this.handleResponse.bind(this);
  }

  handleResponse (resp, value) {
    const { handleResponseCb } = this.props;

    if (200 === resp.statusCode) {
      handleResponseCb(resp, value);
    } else {
      this.setState({
        errorText: <FormattedMessage id='inbox.host_cancel_confirmation_modal.error_refresh' defaultMessage='An error occurred. Please refresh the page and try again.' />,
        spinning: false
      });
    }
  }

  updateBookingAction () {
    const { bookingId, payload } = this.props;

    this.setState({
      spinning: true
    });

    Contracts.cancelBookingContract(payload, 'host', bookingId, PSSessions.Cookies('PSAccess'), response => {
      this.handleResponse(response, payload.private_reason);
    });
  }

  render () {
    const { onClose } = this.props;
    return (
      <BootstrapModal
        onClose={onClose}
        modalClass="host-cancel-confirmation-modal"
        showModal
        header={ <div className="h3" style={{ margin: 0 }}><FormattedMessage id='inbox.host_cancel_confirmation_modal.sure_cancel' defaultMessage='Are you sure you want to cancel?' /></div> }
        body={
          <div>
            <p className="text-center margin-xl-bottom"><FormattedMessage id='inbox.host_cancel_confirmation_modal.guest_refunded' defaultMessage='Your guest will be immediately refunded.' /></p>

            <div className="help-block inline-help text-danger text-center">{this.state.errorText}</div>

            <CTAButton
              buttonText={ <FormattedMessage id='inbox.host_cancel_confirmation_modal.cancel_booking' defaultMessage='Cancel booking' /> }
              classNameString="btn btn-lg btn-primary form margin-xl-top"
              onClickAction={ this.updateBookingAction }
              isDisabled={ false }
              spinning={ this.state.spinning }
            />

            <div className="text-gray-dark text-center margin-xl-top margin-xl-bottom" style={{ cursor: 'pointer' }} onClick={ onClose }><FormattedMessage id='inbox.host_cancel_confirmation_modal.dont_want_cancel' defaultMessage='I don’t want to cancel' /></div>
          </div>
        }
        modalSize="sm-size"
      />
    );
  }
}

HostCancelConfirmationModal.propTypes = {
  onClose: PropTypes.func,
  bookingId: PropTypes.string,
  payload: PropTypes.object,
  handleResponseCb: PropTypes.func
};
